<script  lang="ts" setup="">
import type { ProductFilter } from '~/composables/useProductFilters'

defineProps<{
  filters: ProductFilter<string>[]
  defaultOpen?: boolean
  multiple?: boolean
}>()
</script>

<template>
  <component :is="$attrs.is ?? 'div'">
    <UAccordion
      :type="multiple ? 'multiple' : 'single'"
      :default-value="defaultOpen ? filters.map(f => f.legend) : undefined"
      value-key="label"
      :items="filters.map(({ legend, ...filter }) => ({ label: legend, ...filter }))"
      :ui="{
        root: '!gap-(--gap,0)',
        item: 'px-0 border-b border-green-10 last:border-b pb-(--gap,0)',
        trigger: '!gap-xl',
      }"
    >
      <template #body="{ item }">
        <UiFilterCheckbox
          v-bind="item"
          :ui="{
            legend: 'tracking-wider mb-s',
          }"
        />
      </template>
    </UAccordion>
    <NuxtLink
      :to="{ query: { level: $route.query.level } }"
      class="mt-(--gap,var(--spacing-s)) flex items-center gap-1 self-end no-underline hover:underline"
    >
      <UIcon name="fa7-solid:close" class="size-3" />
      Nullstill filtre
    </NuxtLink>
  </component>
</template>
